import { fromJS } from 'immutable';
import { lenderProductsStatus, lenderProduct, lenderProductOffer } from './types';
import { combineReducerArray } from '../utils/helpers';

const initialState = fromJS({
  network: {
    loading: false,
    error: false,
  },
  activeProducts: [],
  product: {
    network: {
      loading: false,
      error: false,
      type: null,
    },
  },
  manualOffers: {
    product: null,
    network: { loading: false, error: false },
  },
});

const lenderReducerObject = {
  [lenderProductsStatus.request]: (state) =>
    state.withMutations((s) =>
      s.setIn(['network', 'loading'], true).setIn(['network', 'error'], false),
    ),
  [lenderProductsStatus.success]: (state, { response }) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['activeProducts'], fromJS(response)),
    ),
  [lenderProductsStatus.failure]: (state, action) =>
    state.withMutations((s) =>
      s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
    ),
  [lenderProduct.request]: (state, { section }) =>
    state.withMutations((s) =>
      s
        .setIn(['product', 'network', 'loading'], true)
        .setIn(['product', 'network', 'type'], section)
        .setIn(['product', 'network', 'error'], false),
    ),
  [lenderProduct.success]: (state, { section, response }) =>
    state.withMutations((s) =>
      s
        .setIn(['product', section], fromJS(response))
        .setIn(['product', 'network', 'loading'], false)
        .setIn(['product', 'network', 'type'], null)
        .setIn(['product', 'network', 'error'], false),
    ),
  [lenderProduct.failure]: (state, { error }) =>
    state.withMutations((s) =>
      s
        .setIn(['product', 'network', 'loading'], false)
        .setIn(['product', 'network', 'error'], error),
    ),
};

const fundingSearchManualOfferObject = {
  [lenderProductOffer.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['manualOffers', 'network', 'loading'], true)
        .setIn(['manualOffers', 'network', 'error'], false),
    ),
  [lenderProductOffer.success]: (state, { response }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['manualOffers', 'network', 'loading'], false)
        .setIn(['manualOffers', 'network', 'error'], false)
        .setIn(['manualOffers', 'product'], response),
    ),
  [lenderProductOffer.failure]: (state, { error }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['manualOffers', 'network', 'loading'], false)
        .setIn(['manualOffers', 'network', 'error'], error),
    ),
};

export default combineReducerArray(initialState, [
  lenderReducerObject,
  fundingSearchManualOfferObject,
]);
